export const GT_SEA_VIEW: string = 'GT13-SEVI';
